/* Meeras Organics — shared scroll-reveal for story/specs/quote/gallery/cta sections. */
(function () {
  if (window.__meerasRevealInit) return;
  window.__meerasRevealInit = true;

  document.querySelectorAll("[data-meeras-reveal] h2, [data-meeras-reveal] blockquote").forEach((h) => {
    if (h.dataset.split || h.querySelector("br")) return;
    h.dataset.split = "1";
    const words = h.textContent.trim().split(/\s+/).filter(Boolean);
    h.innerHTML = words
      .map((w, i) => `<span class="meeras-word" style="transition-delay:${(i * 0.045).toFixed(2)}s">${w}</span>`)
      .join(" ");
  });

  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("meeras-in")),
    { threshold: 0.18 }
  );
  document.querySelectorAll("[data-meeras-reveal]").forEach((el) => io.observe(el));

  function revealNow() {
    document.querySelectorAll("[data-meeras-reveal]:not(.meeras-in)").forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) el.classList.add("meeras-in");
    });
  }
  addEventListener("scroll", revealNow, { passive: true });
  revealNow();

  const chapterMap = { "meeras-chapter-ingredients": "ingredients", "meeras-chapter-story": "story", "meeras-chapter-benefit": "benefit", "meeras-chapter-blend": "blend", "meeras-chapter-cta": "cta" };
  const navBtns = document.querySelectorAll("#meeras-chapternav [data-chapter]");
  if (navBtns.length) {
    const chapterIO = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const name = chapterMap[e.target.id];
        if (!name) return;
        navBtns.forEach((b) => b.classList.toggle("meeras-nav-active", b.dataset.chapter === name));
      }),
      { threshold: 0.35 }
    );
    Object.keys(chapterMap).forEach((id) => {
      const el = document.getElementById(id);
      if (el) chapterIO.observe(el);
    });
  }
})();
